import React, { useEffect, useState } from "react";
import axios from "axios";
import Utils from "../../Utils";
import _ from "lodash";

const BrandResource = ({ brand }) => {
  const [list, setList] = useState({
    loading: false,
    error: false,
    pageInfo: {},
    data: [],
  });

  const fetchResources = () => {
    setList((prev) => ({ ...prev, loading: true }));
    axios
      .get(Utils.apiUrl("resources.json"), Utils.apiHeaders())
      .then((res) => {
        if (res.data.success) {
          setList((prev) => ({
            ...prev,
            loading: false,
            error: false,
            pageInfo: res.data.pageInfo || {},
            data: res.data.data,
          }));
        } else {
          setList((prev) => ({
            ...prev,
            loading: false,
            error: res.data.message || "Failed to load",
            pageInfo: {},
            data: null,
          }));
        }
      })
      .catch((err) => {
        setList((prev) => ({
          ...prev,
          loading: false,
          error: err.message || "Server error",
          data: null,
        }));
      });
  };

  useEffect(() => {
    fetchResources();
  }, []);

  const getBrandFiles = () => {
    if (list.loading || list.error || !list.data) return [];
    // Photographers search under the "photographer" root; everyone else uses "hotel"
    const rootName = Utils.isPhotographer() ? "photographer" : "hotel";
    const rootFolder = _.get(list, "data.folders", []).find(
      (f) => f.name === rootName,
    );
    return (
      _.get(rootFolder, "folders[0].folders", []).filter((f) =>
        _.replace(brand, /[^a-zA-Z0-9\s]/g, "").startsWith(f.name),
      )[0]?.files || []
    );
  };

  return (
    <div>
      {getBrandFiles().length > 0 && (
        <>
          <h3 className="text-xl font-bold mb-4 flex items-center gap-2">
            <i className="fas fa-folder-tree"></i>
            Brand Photography Guideline
          </h3>
          <div className="flex flex-wrap items-center gap-4">
            {getBrandFiles().map((file) => {
              let iconClass = "fa-file text-gray-400";
              if (file.name.toLowerCase().endsWith(".pdf"))
                iconClass = "fa-file-pdf text-red-600";
              else if (file.name.toLowerCase().endsWith(".docx"))
                iconClass = "fa-file-word text-blue-600";
              else if (file.name.toLowerCase().endsWith(".xlsx"))
                iconClass = "fa-file-excel text-green-600";
              return (
                <a
                  key={file.name}
                  href={Utils.apiUrl(
                    `admin/resources/download?url=${encodeURIComponent(file.url)}&name=${encodeURIComponent(file.name)}`,
                  )}
                >
                  <div className="flex flex-row items-center p-4 bg-blue-50 hover:bg-blue-200 rounded">
                    <i className={`fas ${iconClass} text-3xl`}></i>
                    <div>
                      <div
                        className="truncate text-center"
                        title={file.name}
                        style={{ maxWidth: 250, display: "inline-block" }}
                      >
                        {file.name}
                      </div>
                      <div className="text-xs text-gray-400">
                        {(file.size / 1024 / 1024).toFixed(2)} MB
                      </div>
                    </div>
                    <i className={`fas fa-download text-2xl`}></i>
                  </div>
                </a>
              );
            })}
          </div>
        </>
      )}
    </div>
  );
};

export default BrandResource;
